import createCommonModule from '@/common/store/modules/common';
import { enabledDisabledFormatter } from '@/common/utils/formatter.bool';
import { STATE_ICON_ENABLED, STATE_ICON_DISABLED } from '@/common/utils/statuses';
import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';

function resource() {
  return getClusterId()
  .then(clusterId => `/api/v2/${clusterId}/s3/users`);
}

export default createCommonModule({
  name: 's3Users',
  namespaced: true,
  pagingMode: 's3',
  resource,
  Model: Object,
  plural: ({ data }) => data,
  getters: {
    _mapItem: (state) => id => {
      const user = state.itemsMap[id];
      return user ? {
        ...user,
        name: user.email,
        statusText: enabledDisabledFormatter(user.is_enabled),
        statusIcon: user.is_enabled ? STATE_ICON_ENABLED : STATE_ICON_DISABLED,
        isEnabled: user.is_enabled
      } : {};
    }
  },
  actions: {
    FETCH_KEYS(_, userId) {
      return resource().then(url => this.$api.get(`${url}/${userId}/keys`));
    },
    ADD_KEYS(_, userId) {
      return resource().then(url => this.$api.post(`${url}/${userId}/keys`));
    },
    DELETE_KEYS(_, { userId, keyId }) {
      return resource().then(url => this.$api.delete(`${url}/${userId}/keys/${keyId}`));
    }
  }
});
